var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("select2", {
    class: _vm.inputclass,
    attrs: {
      options: _vm.options,
      value: _vm.value,
      settings: {
        width: "120px",
        minimumResultsForSearch: Infinity,
        allowClear: _vm.emptyname != null,
        placeholder: _vm.emptyname,
      },
    },
    on: {
      change: function ($event) {
        _vm.$emit("input", $event ? parseInt($event) : null)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }